<template>
	<el-drawer title="投递详情" :visible.sync="dialogVisible" size="750px">
		<div class="drawer-content">
			<div class="filter-bar">
				<el-date-picker
					v-model="filters.dateRange"
					type="datetimerange"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					format="yyyy-MM-dd HH:mm:ss"
					value-format="yyyy-MM-dd HH:mm:ss"
					style="margin-right: 10px"
				/>
				<el-button @click="fetchApplications" type="primary">查询</el-button>
				<el-button @click="exportApplications">导出</el-button>
			</div>
			<el-table :data="applyList" stripe style="width: 100%">
				<el-table-column prop="userId" label="用户ID" width="100" />
				<el-table-column label="用户头像" width="100">
					<template slot-scope="scope">
						<img :src="scope.row.avatar" alt="头像" style="width: 40px; height: 40px; border-radius: 50%" />
					</template>
				</el-table-column>
				<el-table-column prop="nickname" label="微信昵称" width="120" />
				<el-table-column prop="activityTitle" label="来源" width="150" />
				<el-table-column prop="applyDate" label="投递日期" width="180">
					<template slot-scope="scope">
						{{ formatDate(scope.row.applyDate) }}
					</template>
				</el-table-column>
				<el-table-column label="操作" width="100">
					<template slot-scope="scope">
						<el-button type="text" @click="viewAttachment(scope.row)">查看附件</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				@current-change="handlePageChange"
				:current-page="pagination.pageNum"
				:page-size="pagination.pageSize"
				:total="pagination.total"
				layout="prev, pager, next"
			/>
		</div>
		<image-viewer v-if="imgViewerVisible" :z-index="9999" :on-close="closeViwer" :url-list="previewImages"  />
	</el-drawer>
</template>

<script>
import { jobApply } from "@/services";
import config from "@/config";
import ImageViewer from 'element-ui/packages/image/src/image-viewer';

export default {
	name: "ApplicationDrawer",
	components: {
		ImageViewer,
	},
	props: {
		value: Boolean,
		jobId: {
			type: [Number, String],
			default: null,
		},
	},
	data() {
		return {
			filters: {
				dateRange: [],
			},
			applyList: [],
			pagination: {
				pageNum: 1,
				pageSize: 10,
				total: 0,
			},
            imgViewerVisible: false,
            previewImages: [],
		};
	},
	computed: {
		dialogVisible: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			},
		},
	},
	watch: {
		value(val) {
			if (val && this.jobId) {
				this.fetchApplications();
			}
		},
		jobId(val) {
			if (val && this.visible) {
				this.fetchApplications();
			}
		},
	},
	methods: {
        closeViwer() {
            this.imgViewerVisible = false
        },
		async fetchApplications() {
			if (!this.jobId) return;
            const dateRange = this.filters.dateRange || [];
			const params = {
				pageNum: this.pagination.pageNum,
				pageSize: this.pagination.pageSize,
				startTime: dateRange[0] || "",
				endTime: dateRange[1] || "",
			};
			const { ok, data } = await jobApply.applyList(this.jobId, params);
			if (ok) {
				this.applyList = data.data.list;
				this.pagination.total = data.data.total || 0;
			}
		},
		formatDate(timestamp) {
			if (!timestamp) return "";
			return new Date(timestamp).toLocaleString("zh-CN");
		},
		handlePageChange(page) {
			this.pagination.pageNum = page;
			this.fetchApplications();
		},
		exportApplications(row) {
			// 预留导出逻辑
			window.open(`${config.host}/srv/jobApply/download-zip/${this.jobId}`, '_blank')
		},
		async viewAttachment(row) {
			// 使用 image-viewer 打开附件图片
			const { ok, data } = await jobApply.attachment(row.id)
            this.previewImages = data.data;
            this.imgViewerVisible = true;
		},
	},
};
</script>

<style scoped>
.drawer-content {
	padding: 16px;
	.filter-bar {
		display: flex;
		align-items: center;
        justify-content: flex-end;
		margin-bottom: 20px;
	}
}
</style>
